import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { WarningModes, AlertMode } from "../../../../Constant";
import { WARNING_MODE } from "../../../../Data/Bonus Ui/SweetAlert";

const WarningMode = () => {
    const displayAlert = () => {
        SweetAlert.fire({ icon: 'warning', title: 'Good job!', text: 'You clicked the button!',confirmButtonColor:"#33BFBF"  });
      };
      return (
        <Col xxl="3" lg="4" sm="6">
          <Card className="height-equal">
            <CommonCardHeader title={WarningModes} span={WARNING_MODE} />
            <CardBody className="btn-showcase">
              <Btn color="warning" className="sweet-1" type="button" onClick={displayAlert}>
                {AlertMode}
              </Btn>
            </CardBody>
          </Card>
        </Col>
      );
};

export default WarningMode;
